import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import VMwareSvg from '../../../assets/icons/clouds/vmware.svg?raw';

export const VMwareLogo = (props) => <CustomSVG svg={VMwareSvg} preserveColors {...props} />;
